module.exports = __webpack_public_path__ + "img/NotThrough.4731601c.svg";